var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestToTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.76108H13V6.76108H16V4.76108H13V1.76108H11V4.76108H8V6.76108H11V9.76108ZM7 18.7611C5.9 18.7611 5.01 19.6611 5.01 20.7611C5.01 21.8611 5.9 22.7611 7 22.7611C8.1 22.7611 9 21.8611 9 20.7611C9 19.6611 8.1 18.7611 7 18.7611ZM17 18.7611C15.9 18.7611 15.01 19.6611 15.01 20.7611C15.01 21.8611 15.9 22.7611 17 22.7611C18.1 22.7611 19 21.8611 19 20.7611C19 19.6611 18.1 18.7611 17 18.7611ZM7.17 15.5111L7.2 15.3911L8.1 13.7611H15.55C16.3 13.7611 16.96 13.3511 17.3 12.7311L21.16 5.72108L19.42 4.76108H19.41L18.31 6.76108L15.55 11.7611H8.53L8.4 11.4911L6.16 6.76108L5.21 4.76108L4.27 2.76108H1V4.76108H3L6.6 12.3511L5.25 14.8011C5.09 15.0811 5 15.4111 5 15.7611C5 16.8611 5.9 17.7611 7 17.7611H19V15.7611H7.42C7.29 15.7611 7.17 15.6511 7.17 15.5111Z",
    fill: "#E33AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestToTeam);
export default __webpack_public_path__ + "static/media/requestToTeam.91e280f626b69ce8a00700d8655f711b.svg";
export { ForwardRef as ReactComponent };